import { useEditableEventsQuery, useHeadJudgeableEventsQuery } from '@scoring/api';
import { ProgressStatus } from '@scoring/types';
import { useAuthentication } from '../hooks/useAuthentication';
import { appsForUser } from './appsForUser';

export const useAvailableApps = () => {
    const { user } = useAuthentication();
    const editable = useEditableEventsQuery();
    const headJudgeable = useHeadJudgeableEventsQuery();

    return {
        apps: appsForUser(user?.roles, {
            canEditEvents: (editable.data?.items.length ?? 0) > 0,
            isHeadJudging: (headJudgeable.data?.items.length ?? 0) > 0,
        }),
        hasLiveHeadJudging: headJudgeable.data?.items.some((x) => x.state === ProgressStatus.Active) ?? false,
        isLoading: !user || editable.isLoading || headJudgeable.isLoading,
    };
};
